import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type StoreService from '@ember-data/store';
import type AbilitiesService from 'ember-can/services/abilities';
import { didCancel, restartableTask, type Task } from 'ember-concurrency';
import type CompanyConfigurationModel from 'garaje/models/company-configuration';
import type LoggerService from 'garaje/services/logger';
import type StateService from 'garaje/services/state';
import loadCompanyConfiguration from 'garaje/utils/load-company-configuration';

export interface LocationOverviewManageAccountSettingsRouteModel {
  loadCompanyConfigurationTask: Task<CompanyConfigurationModel | undefined, []>;
}

class LocationOverviewManageAccountSettingsRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service declare logger: LoggerService;
  @service declare router: RouterService;
  @service declare state: StateService;
  @service declare store: StoreService;

  titleToken = 'Account Settings · Envoy';

  beforeModel(): void {
    if (this.abilities.cannot('visit-account-settings manage-settings')) {
      void this.router.transitionTo('unauthorized');
    }
  }

  loadCompanyConfigurationTask = restartableTask(async () => {
    try {
      return await loadCompanyConfiguration(this.state, this.store);
    } catch (e) {
      if (!didCancel(e)) this.logger.error(<Error>e);
      return undefined;
    }
  });

  model(): LocationOverviewManageAccountSettingsRouteModel {
    void this.loadCompanyConfigurationTask.perform();
    return { loadCompanyConfigurationTask: this.loadCompanyConfigurationTask };
  }
}

export default LocationOverviewManageAccountSettingsRoute;
